import React from 'react';
import { Box, Typography } from '@mui/material';

const truncate = (s, n) => (s && s.length > n ? `${s.slice(0, n - 1).trimEnd()}…` : s || '');

// Facebook/LinkedIn-style share card. ogTitle/ogDescription fall back to the
// page title/description (same as the server), and the image uses the OG image
// if set. Mirrors how a shared link will look in a social feed.
export default function SocialCardPreview({ path = '/', title, description, ogTitle, ogDescription, ogImage }) {
  const t = truncate(ogTitle || title || 'Page title', 70);
  const d = truncate(ogDescription || description || 'Description preview…', 120);

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', maxWidth: 500, bgcolor: 'background.paper' }}>
      <Box
        sx={{
          width: '100%',
          aspectRatio: '1.91 / 1',
          bgcolor: 'grey.200',
          backgroundImage: ogImage ? `url(${ogImage})` : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {!ogImage && (
          <Typography variant="caption" color="text.secondary">
            No social image set (1200×630 recommended)
          </Typography>
        )}
      </Box>
      <Box sx={{ p: 1.5, bgcolor: '#f2f3f5' }}>
        <Typography variant="caption" sx={{ textTransform: 'uppercase', color: '#606770' }}>
          jethl.com{path === '/' ? '' : path}
        </Typography>
        <Typography sx={{ fontWeight: 600, color: '#1d2129', fontSize: 15, lineHeight: 1.3 }}>
          {t}
        </Typography>
        <Typography sx={{ color: '#606770', fontSize: 13, mt: 0.25 }}>
          {d}
        </Typography>
      </Box>
    </Box>
  );
}
